import React, { useState } from 'react';
import { useFeatureFlags } from '../context/FeatureFlagsContext';
import './Sidebar.css';

const Sidebar = ({ isAdmin, activeItem, onItemClick, isMobileOpen, onCloseMobile }) => {
  const [collapsed, setCollapsed] = useState(false);
  const { flags } = useFeatureFlags();

  const toggleSidebar = () => {
    setCollapsed(!collapsed);
  };

  const adminMenuItems = [
    { id: 'dashboard', icon: 'fas fa-tachometer-alt', label: 'Dashboard' },
    { id: 'users', icon: 'fas fa-users', label: 'User Management' },
    { id: 'content', icon: 'fas fa-book', label: 'Content Management' },
    { id: 'daily-living-admin', icon: 'fas fa-hands-wash', label: 'Daily Living Skills' },
    { id: 'reports', icon: 'fas fa-chart-bar', label: 'Reports & Analytics' },
    { id: 'features', icon: 'fas fa-toggle-on', label: 'Features' },
  ];

  const studentMenuItems = [
    { id: 'sight-words', icon: 'fas fa-book', label: 'Sight Words' },
    { id: 'scramble', icon: 'fas fa-puzzle-piece', label: 'Scramble Words' },
    { id: 'category', icon: 'fas fa-tags', label: 'Category Words' },
    { id: 'math', icon: 'fas fa-calculator', label: 'Math Concepts' },
    { id: 'daily-living', icon: 'fas fa-hands-wash', label: 'Daily Living Skills' },
    { id: 'progress', icon: 'fas fa-chart-line', label: 'Progress' },
    { id: 'achievements', icon: 'fas fa-trophy', label: 'Achievements' },
    { id: 'weekly', icon: 'fas fa-calendar-week', label: 'Weekly Progress' }
  ];

  const menuItems = (isAdmin ? adminMenuItems : studentMenuItems)
    .filter(item => item.id !== 'math' || flags.math_concepts_enabled !== false)
    .filter(item => item.id !== 'daily-living' || flags.daily_living_enabled !== false);

  const handleMenuItemClick = (itemId) => {
    onItemClick(itemId);
    if (onCloseMobile) {
      onCloseMobile();
    }
  };

  return (
    <>
      {isMobileOpen && <div className={`sidebar-overlay ${isMobileOpen ? 'mobile-open' : ''}`} onClick={onCloseMobile} />}
      <div className={`sidebar ${collapsed ? 'collapsed' : ''} ${isMobileOpen ? 'mobile-open' : ''}`}>
      <div className="sidebar-header">
        <div className="logo">
          <div className="logo-icon">🦋</div>
          {!collapsed && <h2>Learning Menu</h2>}
        </div>
        <button className="toggle-btn" onClick={toggleSidebar}>
          <i className={`fas fa-chevron-${collapsed ? 'right' : 'left'}`}></i>
        </button>
      </div>
      
      <ul className="sidebar-menu">
        {menuItems.map(item => (
          <li
            key={item.id}
            className={activeItem === item.id ? 'active' : ''}
            onClick={() => handleMenuItemClick(item.id)}
          >
            <i className={item.icon}></i>
            {!collapsed && <span className="menu-text">{item.label}</span>}
          </li>
        ))}
      </ul>
      </div>
    </>
  );
};

export default Sidebar;